import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodeCreatedSubscription = gql`
  subscription surfaceNodeCreated($surface: ID!) {
    surfaceNodeCreated(surface: $surface) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;
